import React, { useEffect } from "react";
import { useLocation, withRouter } from "react-router-dom";
import PaymentService from "../../services/PaymentService";
import { CircularLoader } from "@plum-xoxo/admin-dsm";
import { NotificationManager } from "react-notifications";
import { app_path } from "config";
import { PAYMENT_STATUS_NAME_TO_CODE } from "../../constants/PaymentConstant";

const PayoneerPaymentCallback = (props) => {
  const location = useLocation();
  const search = location.search;
  const salesOrderId = new URLSearchParams(search).get("transactionId") || null;
  const amount = new URLSearchParams(search).get("amount") || 0;
  const redirectPath = localStorage.getItem("payoneerRedirectPath");
  const origin = localStorage.getItem("payoneerRechargeOrigin");
  const company_recharge =
    localStorage.getItem("payoneerRechargeCompanyType") || 0;

  useEffect(() => {
    if (salesOrderId) {
      checkForPaymentStatus(salesOrderId);
    }
    return;
  }, []);

  const checkForPaymentStatus = (salesOrderId) => {
    const paymentStatusOptions = {
      internalReferenceId: salesOrderId,
    };
    PaymentService.getPaymentStatus(paymentStatusOptions).then((response) => {
      if (response?.getPaymentStatus) {
        const stateData = JSON.stringify({
          origin: origin ? origin : "plum",
          order_id: salesOrderId,
          status:
            response?.getPaymentStatus?.status ===
              PAYMENT_STATUS_NAME_TO_CODE.success ||
            response?.getPaymentStatus?.status ===
              PAYMENT_STATUS_NAME_TO_CODE.pending
              ? "success"
              : "fail",
          amount: parseFloat(
            amount ? amount : localStorage.getItem("payoneerRechargeAmount")
          ).toFixed(2),
          company_recharge: parseInt(company_recharge),
          redirectPath: redirectPath ? redirectPath : `/${app_path}/recharge`,
        });
        props.history.push({
          pathname: `/${app_path}/payoneer-payment-status/${stateData.status}/`,
          state: stateData,
        });
      } else {
        NotificationManager.error(response.getPaymentStatus.msg, "Error");
      }
    });
  };

  return (
    <CircularLoader
      size="lg"
      vertical
      center
      content="Please do not refresh the page and wait while we are processing your
          payment..."
    />
  );
};

export default withRouter(PayoneerPaymentCallback);
